import React, { Component } from 'react';
import axios from 'axios';
import * as serverconfig from '../../serverconn';

import SaccoBaseRouter from '../../../saccoroutes';
import HubBaseRouter from '../../../hubroutes';

class ConditionalRouter extends Component {
  state = {
    userprofile: {},
    loading: true
  };

  componentDidMount() {
    this.fetchUserProfile();
  }

  fetchUserProfile = () => {
    const token = localStorage.getItem('token');
    console.log('🔍 ConditionalRouter: Token from localStorage:', token);
    
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`
      };
      console.log('🔍 ConditionalRouter: Headers:', headers);

      axios.get(serverconfig.backendserverurl + `/current_user_profile`, { headers })
        .then(res => {
          console.log('🔍 ConditionalRouter: User profile data:', res.data);
          this.setState({
            userprofile: res.data,
            loading: false
          });
        })
        .catch(err => {
          console.error('🔍 ConditionalRouter: Error fetching user profile:', err);
          console.error('🔍 ConditionalRouter: Error response:', err.response);
          console.error('🔍 ConditionalRouter: Error status:', err.response?.status);
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false });
    }
  };

  render() {
    const { userprofile, loading } = this.state;

    if (loading) {
      return <div>Loading...</div>;
    }

    // Check if user is a hub manager (has coodinated_hub assigned)
    const isHubManager = userprofile.coodinated_hub !== null && userprofile.coodinated_hub !== undefined;
    console.log('🔍 ConditionalRouter: isHubManager:', isHubManager, 'coodinated_hub:', userprofile.coodinated_hub);

    // Return appropriate router based on user role (layout is handled by App.js)
    if (isHubManager) {
      return <HubBaseRouter />;
    } else {
      return <SaccoBaseRouter />;
    }
  }
}

export default ConditionalRouter;
